import React, { useEffect } from "react"
import FooterComponent from "../../components/footer"
import ReactHelmet from "src/components/react-helmet"

const ClientFeedbackForm = () => {
  useEffect(() => {
    try {
      var script = document.createElement("script")
      script.src = "https://paperform.co/__embed"
      script.async = true
      document.body.appendChild(script)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <>
      <ReactHelmet
        url="client-feedback"
        title={`Client Feedback`}
        description="Tolobi - Rental Made Easy"
      />
      <div data-paperform-id="tolobi-ra-client-feedback"></div>
      <FooterComponent />
    </>
  )
}

export default ClientFeedbackForm
